var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebtCollection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 344.15 268.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:11px;}.cls-2,.cls-3{fill:none;}.cls-4{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m282.35,0v99.63H111.78c-15.22,0-27.6,12.38-27.6,27.6v122.94c0,5.41,1.56,10.46,4.28,14.73H0V0h282.35Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 99.18,
    y: 114.63,
    width: 239.47,
    height: 148.14,
    rx: 12.6,
    ry: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 282.35,
    y: 218.8,
    width: 33.28,
    height: 19.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m152.51,171.37v-7.15h6.6c1.1,0,2,.9,2,2v5.15h-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m128.16,171.37v-5.15c0-1.1.9-2,2-2h6.6v7.15h-8.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m152.51,188.8v-7.15h8.6v5.15c0,1.1-.9,2-2,2h-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m128.16,186.8v-5.15h8.6v7.15h-6.6c-1.1,0-2-.9-2-2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.51,
    y: 173.37,
    width: 8.6,
    height: 6.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.16,
    y: 173.37,
    width: 8.6,
    height: 6.28
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 138.76,
    y: 164.22,
    width: 11.75,
    height: 24.48
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 99.18,
    y: 114.63,
    width: 239.47,
    height: 148.14,
    rx: 12.6,
    ry: 12.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.78,
    y: 49.41,
    width: 239.47,
    height: 148.14,
    rx: 12.6,
    ry: 12.6,
    transform: "translate(-33.74 60.6) rotate(-20.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.17,
    y: 76.9,
    width: 239.47,
    height: 25.78,
    transform: "translate(-22.73 54.04) rotate(-20.52)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.31,
    y: 131.68,
    width: 133.13,
    height: 17.41,
    transform: "translate(-40.65 56.19) rotate(-20.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 203.52,
    y: 99.76,
    width: 33.28,
    height: 17.41,
    transform: "translate(-24.05 84.06) rotate(-20.52)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtCollection);
export default __webpack_public_path__ + "static/media/debtCollection.06091939678242fc66d82f74d5b40170.svg";
export { ForwardRef as ReactComponent };